import { Routes, RouterModule }  from '@angular/router';
import { Teacher } from './components/main/teacher.component';
import { AuthenticatedRoutesGuard } from '../app/services/authenticated-routes-guard.service';
import { ProductView } from './../../modules/shared/components/product-view/product-view.component';
import { TeacherProductViewResolverService } from './services/teacher-product-view.resolver.service';
import { ActivityView } from './../../modules/shared/components/activity-view/activity-view.component';
import { TeacherActivityViewResolverService } from './services/teacher-activity-view-resolver.service';
import { ActivityLaunch } from './../../modules/shared/components/activity-launch/activity-launch.component';
import { GroupSelection } from './components/group-selection/group-selection.component';
import { SaveWarningGuard } from 'modules/shared/services/save-warning-guard.service';
import { CanDeactivateLPGuard } from 'modules/shared/services/can-deactivate-lp-guard.service';

const routes: Routes = [
    {
        path: 'teacher', component: Teacher, canActivate: [AuthenticatedRoutesGuard], children: [
            { path: ':spaceId/product/:productCode', component: ProductView, resolve: { productViewResolverData: TeacherProductViewResolverService } },
            { path: ':spaceId/product/:productCode/view', component: ActivityView, canDeactivate: [CanDeactivateLPGuard],
              resolve: { activityViewResolverData: TeacherActivityViewResolverService }, children: [
                { path: 'item/:itemId', component: ActivityLaunch, canDeactivate: [SaveWarningGuard] }
            ]},
            {path: ':spaceId/class/:classId/product/:productCode/item/:itemId/group-selection', component: GroupSelection , resolve: { productViewResolverData: TeacherProductViewResolverService }},
            { path: ':spaceId/class/:classId/product/:productCode', component: ProductView, resolve: { productViewResolverData: TeacherProductViewResolverService } },
            { path: ':spaceId/class/:classId/product/:productCode/view', component: ActivityView, canDeactivate: [CanDeactivateLPGuard],
              resolve: { activityViewResolverData: TeacherActivityViewResolverService }, children: [
                { path: 'item/:itemId', component: ActivityLaunch, canDeactivate: [SaveWarningGuard] },
            ]},
        ]
    }
];

export const ROUTES = RouterModule.forChild(routes);
